module.exports = __webpack_public_path__ + "img/nivel_luz_blue.948a9432.svg";